import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import ScrollTop from './utils/scrollTop';
import { persistStore } from "redux-persist"
import store from './reducers/store';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import './index.css'

//the persist gate will be used to save the store state, if a user closes the tab or browser and reopens, the state will still be there.
const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistStore(store)}>
            <BrowserRouter>
                <ScrollTop />
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>
);